import {RiskCheckEv} from '@/dicts/qualify';
import {ENV} from '../modules/Qualify/common/env';
import {cookies} from '../modules/App';

const xaf = require('@baidu/antifraud-xaf3');
const UA = require('ua-device');

function needZid() {
    return ENV.baidu() || ENV.baiduyun();
}

function getBaiduRelatedAppVersion() {
    return ENV.baiduVersion() || ENV.baiduYunVersion();
}

function getBaiduAppCUID() {
    return cookies.get('BAIDUCUID') || '';
}

function getZid(ev: RiskCheckEv) {
    return new Promise(resolve => {
        try {
            xaf.hgzAs(
                {
                    aid: '12971',
                    ev,
                    c: getBaiduAppCUID(),
                    a: '',
                    app: needZid() ? (ENV.ios() ? 'ios' : ENV.android() ? 'android' : 'universe') : 'universe',
                    ver: needZid() ? getBaiduRelatedAppVersion() : '',
                },
                (zid: string) => {
                    resolve(zid || '');
                }
            );
        } catch (e) {
            resolve('');
        }
    });
}

export async function safeSDKReport(ev: RiskCheckEv, userId?: string) {
    return new Promise(resolve => {
        try {
            xaf.report({
                aid: '12971',
                // 空字符表示百度系用户
                ut: '',
                // passuid或者用户id
                a: userId,
                // 业务方自定义
                biz: {
                    ev,
                },
                c: getBaiduAppCUID(),
                complete: (data: any) => {
                    const code = +data?.code;
                    if ([0, 1].includes(code)) {
                        resolve(data.jt || '');
                    }
                    else {
                        resolve('');
                    }
                },
            });
        } catch (e) {
            resolve('');
        }
    });
}

export async function riskCheck(ev: RiskCheckEv) {
    const z = needZid() ? await getZid(ev) : '';
    const userId = window?.framework?.constants?.userid;
    const jt = await safeSDKReport(ev, userId);
    const jsEnv = ENV.baiduyun() || ENV.baidu() ? 'h5n' : 'h5';
    const output = new UA(window.navigator.userAgent);
    const model = output.device?.model;
    const brand = output.device?.manufacturer;
    return Promise.resolve({
        z,
        jt,
        ev,
        model,
        brand,
        'js_env': jsEnv,
    });
}
